import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

import './App.css';
import Camera from './components/CameraWithAddress'




function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
       <Route path="/" element={<Camera />} />
       
      </Routes>
    </Router>
  );
}

export default App;
